module.exports = __webpack_public_path__ + "static/media/CICLO_4_PAZ_Y_COMUNIDAD_DIGITAL_2022.c8b3110f.jpg";